import React from 'react';
import { CommandScene } from '../scenes/CommandScene';
export function ExperienceIntro() {
  return <section className="py-24 md:py-32" data-id="element-24" data-mp="1c7zllfj18s9z">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-5 md:px-8 lg:grid-cols-2 lg:gap-20" data-id="element-25" data-mp="1c90upeghn4p2">
        <div data-id="element-26" data-mp="1q4uw7cexmrs5">
          <h2 className="text-balance text-3xl font-semibold tracking-display sm:text-4xl md:text-5xl md:leading-[1.05]" data-id="element-27" data-mp="1m5do0b84fgja">
            Complex systems. A familiar experience.
          </h2>
          <div className="mt-7 space-y-5 text-lg leading-relaxed text-ink-soft" data-id="element-28" data-mp="202shps5eqah2">
            <p data-id="element-29" data-mp="1v5sbnh8k57py">
              Noetivra is a sleek dashboard for managing and operating SyNeural’s underlying connected knowledge and human
              capability systems. It helps people explore relationships, conduct assessments, review findings, coordinate
              services, and put knowledge into action.
            </p>
            <p data-id="element-30" data-mp="2dwjv5bm9eei2">
              Its glassmorphism design combines frosted-glass panels, subtle glowing data overlays, and clean white spaces.
              Navigation feels familiar, controls respond naturally, and complex information becomes easy to explore.
            </p>
          </div>
        </div>
        <div className="bg-dots rounded-[32px] px-2 py-10 sm:px-8" data-id="element-31" data-mp="1dxqs352vb8ep">
          <CommandScene data-id="element-32" data-mp="1dwfnx45ifyn2" />
        </div>
      </div>
    </section>;
}